import { wave } from '@/api/config/index.js';
import { Shop } from '@/store/shop';
import Router from 'next/router';

const baseURL = `${process.env.NEXT_PUBLIC_WAVE_HOSTNAME}/api/orders`;
const baseURLV31 = `${process.env.NEXT_PUBLIC_WAVE_HOSTNAME}/api/v3.1/orders`;
const baseURLProductsV31 = `${process.env.NEXT_PUBLIC_WAVE_HOSTNAME}/api/v3.1/products`;

export async function getOrderLimitations(shopId) {
  try {
    const response = await wave.get(`${baseURL}/get/limitations`, {
      params: { shopId },
    });
    return response?.data?.payload?.orders;
  } catch (error) {
    return {};
  }
}

export async function getOrdersHistoryV31({
  sort = 'createdAt|desc',
  pageNumber = 0,
  pageSize = 15,
  statusState, // = 'CLIENT_VISIBLE',
}) {
  try {
    const response = await wave.get(baseURLV31, {
      params: { sort, pageSize, pageNumber, statusState },
    });
    return response?.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getOrderItemsV31({ orderId }) {
  const shopId = Shop?.getValue()?.selectedShop?._id;

  try {
    const response = await wave.get(`${baseURLV31}/${orderId}/items`, {
      params: { populateDefinition: true, ...(shopId && { shop: shopId }) },
    });
    return response?.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getProductFromGroups({ groupId, pageParam, token }) {
  const shopId = Shop?.getValue()?.selectedShop?._id;
  try {
    const response = await wave.get(`${baseURLProductsV31}`, {
      headers: {
        appId: process.env.appId,
        authorization: `Bearer ${token}`,
      },
      params: {
        available: true,
        pageNumber: 0,
        pageSize: 25,
        catalogGroups: groupId,
        ...(shopId && { shop: shopId }),
      },
    });
    return response?.data;
  } catch (error) {
    return Promise.reject(error);
  }
}

export async function getOrderEditModes(orderId) {
  const response = await wave.get(`/v3/orders/${orderId}/modify-check`);

  return response.data;
}

export async function checkOrderDetails(orderId, resource) {
  const response = await wave.put(`/v3/orders/${orderId}/details/check`, resource);

  return response.data;
}

export async function editOrderDetails(orderId, resource) {
  let locale = '';
  if (Router.locale !== 'el') {
    locale = Router.locale;
  }
  const paymentRedirectionUrl = {
    onSuccess: `${process.env.NEXT_PUBLIC_HOSTNAME}/${locale}/thank-you`,
    onError: `${process.env.NEXT_PUBLIC_HOSTNAME}/${locale}/checkout/error`,
    onCancel: `${process.env.NEXT_PUBLIC_HOSTNAME}/${locale}/checkout/cancel`,
  };

  const response = await wave.put(`/v3/orders/${orderId}/details`, {
    ...resource,
    paymentRedirectionUrl: paymentRedirectionUrl,
  });

  return response.data;
}
export async function getOrderDetails(orderId, apiKey) {
  const headers = {};
  if (apiKey) {
    headers['x-api-key'] = apiKey;
  }
  const response = await wave.get(`/v3/orders/${orderId}`, { headers });

  return response.data;
}
